const URLS_QUERY_PARAMS_BLACKLIST = ['access_token', 'x_token', 'direct_token', 'token', 'email']

const cleanURLFromForbiddenParams = (url: string) => {
  const parsedURL = new URL(decodeURIComponent(url))

  URLS_QUERY_PARAMS_BLACKLIST.forEach((paramName) => {
    if (parsedURL.searchParams.has(paramName)) {
      parsedURL.searchParams.set(paramName, 'REPLACED')
    }
  })

  const hashParamsArray = parsedURL.hash.substring(1).split('&')

  hashParamsArray.forEach((hashParam, index) => {
    URLS_QUERY_PARAMS_BLACKLIST.forEach((blackListParam) => {
      const splittedHashParam = hashParam.split('=')

      if (splittedHashParam[0] === blackListParam) {
        hashParamsArray[index] = `${splittedHashParam[0]}=REPLACED`
      }
    })
  })

  parsedURL.hash = `#${hashParamsArray.join('&')}`

  return encodeURIComponent(parsedURL.toString())
}

/*
    Матчит referrer в группу referrer
    -version=1.0.0,-referrer=http://localhost:8000/home -> https://localhost:8000/home
*/
const findReferrerParamsRegex = /-referrer=(?<referrer>.*?)(,-|$)/

const cleanupReferrerFromForbiddenParams = (vars: string) => {
  const match = vars.match(findReferrerParamsRegex)

  if (match?.groups?.referrer) {
    const cleanedReferrer = cleanURLFromForbiddenParams(match.groups.referrer)

    return vars.replaceAll(match.groups.referrer, cleanedReferrer)
  }

  return vars
}

const yaSendWrapper =
  (send: typeof window.Ya.Rum.send): typeof window.Ya.Rum.send =>
  (link, path, vars, ...rest) => {
    send(link, path, cleanupReferrerFromForbiddenParams(vars), ...rest)
  }

window.Ya.Rum.send = yaSendWrapper(window.Ya.Rum.send)

export {}
